import React from 'react'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store/Store'
import { BrowserRouter } from 'react-router-dom'
import ReactDOM from 'react-dom'

// Render the React application into the root element
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root') // This specifies where to render the app
)

reportWebVitals()
